const AG_GRID_LOCALE_KR = {
  selectAll: '(모두 선택)',
  selectAllSearchResults: '(모든 검색 결과 선택)',
  addCurrentSelectionToFilter: '지금 선택 영역을 필터에 추가',
  searchOoo: '검색하세요...',
  blanks: '(비어 있음)',
  noMatches: '검색 결과가 없습니다',
  filterOoo: '필터...',
  equals: '같음',
  notEqual: '같지 않음',
  blank: '비어 있음',
  notBlank: '비어 있지 않음',
  empty: '하나를 선택하세요',
  lessThan: '보다 작은',
  greaterThan: '보다 큰',
  lessThanOrEqual: '보다 작거나 같은',
  greaterThanOrEqual: '보다 크거나 같은',
  inRange: '사이',
  inRangeStart: '부터',
  inRangeEnd: '까지',
  contains: '포함하는',
  notContains: '포함하지 않는',
  startsWith: '시작하는',
  endsWith: '끝나는',
  dateFormatOoo: 'yyyy-mm-dd',
  before: '이전',
  after: '이후',
  andCondition: '그리고',
  orCondition: '또는',
  applyFilter: '적용',
  resetFilter: '초기화',
  clearFilter: '지우기',
  cancelFilter: '취소',
  textFilter: '텍스트 필터',
  numberFilter: '숫자 필터',
  dateFilter: '날짜 필터',
  setFilter: '집합 필터',
  groupFilterSelect: '필드를 선택하세요:',
  advancedFilterContains: '포함하는',
  advancedFilterNotContains: '포함하지 않는',
  advancedFilterTextEquals: '같은',
  advancedFilterTextNotEqual: '같지 않은',
  advancedFilterStartsWith: '시작하는',
  advancedFilterEndsWith: '끝나는',
  advancedFilterBlank: '비어 있는',
  advancedFilterNotBlank: '비어 있지 않은',
  advancedFilterEquals: '=',
  advancedFilterNotEqual: '!=',
  advancedFilterGreaterThan: '>',
  advancedFilterGreaterThanOrEqual: '>=',
  advancedFilterLessThan: '<',
  advancedFilterLessThanOrEqual: '<=',
  advancedFilterTrue: 'true 인',
  advancedFilterFalse: 'false 인',
  advancedFilterAnd: '그리고',
  advancedFilterOr: '또는',
  advancedFilterApply: '적용',
  advancedFilterBuilder: '빌더',
  advancedFilterValidationMissingColumn: '열을 선택해주세요',
  advancedFilterValidationMissingOption: '옵션을 선택해주세요',
  advancedFilterValidationMissingValue: '값을 지정해주세요',
  advancedFilterValidationInvalidColumn: '열을 찾을 수 없습니다',
  advancedFilterValidationInvalidOption: '옵션을 찾을 수 없습니다',
  advancedFilterValidationMissingQuote: '값에 따옴표를 입력해주세요',
  advancedFilterValidationNotANumber: '값에 숫자를 입력해주세요',
  advancedFilterValidationInvalidDate: '유효한 날짜가 아닙니다',
  advancedFilterValidationMissingCondition: '조건을 입력해주세요',
  advancedFilterValidationJoinOperatorMismatch: '하나의 조건에는 한 가지 연산만 가능합니다',
  advancedFilterValidationInvalidJoinOperator: '연산자를 찾을 수 없습니다',
  advancedFilterValidationMissingEndBracket: '괄호를 입력해주세요',
  advancedFilterValidationExtraEndBracket: '괄호를 여러번 입력하셨습니다',
  advancedFilterValidationMessage: '수식에 오류가 있습니다. ${변수} - ${변수}',
  advancedFilterValidationMessageAtEnd: '수식에 오류가 있습니다. 수식 마지막 ${변수}.',
  advancedFilterBuilderTitle: '고급 필터',
  advancedFilterBuilderApply: '적용',
  advancedFilterBuilderCancel: '취소',
  advancedFilterBuilderAddButtonTooltip: '필터 또는 그룹을 추가하세요',
  advancedFilterBuilderRemoveButtonTooltip: '삭제',
  advancedFilterBuilderMoveUpButtonTooltip: '위로 이동',
  advancedFilterBuilderMoveDownButtonTooltip: '아래로 이동',
  advancedFilterBuilderAddJoin: '그룹 추가',
  advancedFilterBuilderAddCondition: '필터 추가',
  advancedFilterBuilderSelectColumn: '열을 선택하세요',
  advancedFilterBuilderSelectOption: '옵션을 선택하세요',
  advancedFilterBuilderEnterValue: '값을 입력하세요...',
  advancedFilterBuilderValidationAlreadyApplied: '이미 적용된 필터입니다.',
  advancedFilterBuilderValidationIncomplete: '완성되지 않은 조건이 있습니다.',
  advancedFilterBuilderValidationSelectColumn: '열을 선택해주세요.',
  advancedFilterBuilderValidationSelectOption: '옵션을 선택해주세요.',
  advancedFilterBuilderValidationEnterValue: '값을 입력해주세요. ',
  columns: '열',
  filters: '필터',
  pivotMode: '피벗 모드',
  groups: '행 그룹',
  rowGroupColumnsEmptyMessage: '행 그룹을 만들려면 여기에 끌어다 놓으세요',
  values: '값',
  valueColumnsEmptyMessage: '집계하려면 여기에 끌어다 놓으세요',
  pivots: '열 라벨',
  pivotColumnsEmptyMessage: '열 라벨을 설정하려면 여기에 끌어다 놓으세요',
  group: '그룹',
  rowDragRow: '열',
  rowDragRows: '열',
  loadingOoo: '로딩 중...',
  loadingError: '오류',
  noRowsToShow: '표시할 행이 없습니다',
  enabled: '활성화',
  pinColumn: '열 고정',
  pinLeft: '왼쪽 고정',
  pinRight: '오른쪽 고정',
  noPin: '고정 없음',
  valueAggregation: '값 집계',
  noAggregation: '없음',
  autosizeThiscolumn: '열 크기 자동조정',
  autosizeAllColumns: '모든 열 크기 자동조정',
  groupBy: '그룹 만들기',
  ungroupBy: '그룹 해제하기',
  ungroupAll: '모든 그룹 해제하기',
  addToValues: '값에 ${변수} 추가',
  removeFromValues: '값에 ${변수} 삭제',
  addToLabels: '분류에 ${변수} 추가',
  removeFromLabels: '분류에 ${변수} 삭제',
  resetColumns: '열 초기화',
  expandAll: '모든 행 그룹 펼치기',
  collapseAll: '모든 행 그룹 접기',
  copy: '복사',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: '제목과 함께 복사',
  copyWithGroupHeaders: '그룹 제목과 함께 복사',
  cut: '자르기',
  paste: '붙여넣기',
  ctrlV: 'Ctrl+V',
  export: '다운로드',
  csvExport: 'CSV 다운로드',
  excelExport: 'Excel 다운로드',
  sum: '합계',
  first: '첫',
  last: '마지막',
  min: '최소',
  max: '최대',
  none: '없음',
  count: '갯수',
  avg: '평균',
  filteredRows: '필터된',
  selectedRows: '선택된',
  totalRows: '행 합계',
  totalAndFilteredRows: '행',
  more: '더보기',
  to: '으로',
  of: '중',
  page: '페이지',
  pageLastRowUnknown: '?',
  nextPage: '다음 페이지',
  lastPage: '마지막 페이지',
  firstPage: '첫 페이지',
  previousPage: '이전 페이지',
  pageSizeSelectorLabel: '페이지 수',
  pivotColumnGroupTotals: '합계',
  pivotChartAndPivotMode: '피벗 차트 & 피벗 모드',
  pivotChart: '피벗 차트',
  chartRange: '차트 범위',
  columnChart: '세로 막대',
  groupedColumn: '묶은',
  stackedColumn: '누적',
  normalizedColumn: '100% 누적',
  barChart: '가로 막대',
  groupedBar: '묶은',
  stackedBar: '누적',
  normalizedBar: '100% 누적',
  pieChart: '원형',
  pie: '원',
  doughnut: '도넛',
  line: '선형',
  xyChart: 'X Y (분산형)',
  scatter: '분산',
  bubble: '버블',
  areaChart: '영역형',
  area: '영역',
  stackedArea: '누적',
  normalizedArea: '100% 누적',
  histogramChart: '히스토그램',
  histogramFrequency: '빈도',
  columnLineCombo: '세로 막대 & 선',
  AreaColumnCombo: '영역 & 세로 막대',
  pivotChartTitle: '피벗 차트',
  rangeChartTitle: '범위 차트',
  settings: '설정',
  data: '데이터',
  format: '양식',
  categories: '카테고리',
  defaultCategory: '(없음)',
  series: '시계열',
  xyValues: 'X Y 값',
  paired: '페어 모드',
  axis: '축',
  navigator: '내비게이터',
  color: '색상',
  thickness: '두께',
  xType: 'X 타입',
  automatic: '자동',
  category: '카테고리',
  number: '숫자',
  time: '시간',
  autoRotate: '자동 회전',
  xRotation: 'X축 회전',
  yRotation: 'Y축 회전',
  ticks: '눈금',
  width: '너비',
  height: '높이',
  length: '길이',
  padding: '패딩',
  spacing: '간격',
  chart: '차트',
  title: '제목',
  titlePlaceholder: '차트 제목 - 편집하려면 더블 클릭하세요',
  background: '배경',
  font: '폰트',
  top: '상단',
  right: '오른쪽',
  bottom: '하단',
  left: '왼쪽',
  labels: '라벨',
  size: '크기',
  minSize: '최소 크기',
  maxSize: '최대 크기',
  legend: '범례',
  position: '위치',
  markerSize: '마커 크기',
  markerStroke: '마커 테두리',
  markerPadding: '마커 페딩',
  itemSpacing: '아이템 간격',
  itemPaddingX: '아이템 X축 패딩',
  itemPaddingY: '아이템 Y축 패딩',
  layoutHorizontalSpacing: '가로 간격',
  layoutVerticalSpacing: '세로 간격',
  strokeWidth: '테두리 굵기 ',
  lineDash: '점선',
  offset: '오프셋',
  offsets: '오프셋',
  tooltips: '툴팁',
  callout: '말풍선',
  markers: '마커',
  shadow: '그림자',
  blur: '흐림 처리',
  xOffset: 'X축 오프셋',
  yOffset: 'Y축 오프셋',
  lineWidth: '선 굵기',
  normal: '보통',
  bold: '굵게',
  italic: '기울이게',
  boldItalic: '굵고 기울이게',
  predefined: '미리 정의된',
  fillOpacity: '채우기 불투명도',
  strokeOpacity: '테두리 불투명도',
  histogramBinCount: '계급구간 갯수',
  columnGroup: '세로 막대',
  barGroup: '가로 막대',
  pieGroup: '원',
  lineGroup: '선',
  scatterGroup: 'X Y (분산)',
  areaGroup: '영역',
  histogramGroup: '히스토그램',
  combinationGroup: '콤보',
  groupedColumnTooltip: '묶은',
  stackedColumnTooltip: '누적',
  normalizedColumnTooltip: '100% 누적',
  groupedBarTooltip: '묶은',
  stackedBarTooltip: '누적',
  normalizedBarTooltip: '100% 누적',
  pieTooltip: '원',
  doughnutTooltip: '도넛',
  lineTooltip: '선',
  groupedAreaTooltip: '영역',
  stackedAreaTooltip: '누적',
  normalizedAreaTooltip: '100% 누적',
  scatterTooltip: '분산',
  bubbleTooltip: '버블',
  histogramTooltip: '히스토그램',
  columnLineComboTooltip: '세로 막대 & 선',
  areaColumnComboTooltip: '영역 & 세로 막대',
  customComboTooltip: '커스텀 콤보',
  noDataToChart: '차트를 생성할 데이터가 없습니다',
  pivotChartRequiresPivotMode: '피벗 차트를 이용하려면 피벗 모드를 켜주세요',
  chartSettingsToolbarTooltip: '메뉴',
  chartLinkToolbarTooltip: '그리드에 연결됨',
  chartUnlinkToolbarTooltip: '그리드에 연결되지 않음',
  chartDownloadToolbarTooltip: '차트 다운로드',
  seriesChartType: '시계열 차트 형식',
  seriesType: '시계열 형식',
  secondaryAxis: '보조 축',
  ariaAdvancedFilterBuilderItem: '${변수}. Level ${변수}. 편집하려면 Enter를 누르세요.',
  ariaAdvancedFilterBuilderItemValidation:
    '${변수}. Level ${변수}. ${변수} 편집하려면 Enter를 누르세요.',
  ariaAdvancedFilterBuilderList: '고급 필터 만들기 목록',
  ariaAdvancedFilterBuilderFilterItem: '필터 조건',
  ariaAdvancedFilterBuilderGroupItem: '필터 그룹',
  ariaAdvancedFilterBuilderColumn: '열',
  ariaAdvancedFilterBuilderOption: '옵션',
  ariaAdvancedFilterBuilderValueP: '값',
  ariaAdvancedFilterBuilderJoinOperator: '연산자',
  ariaAdvancedFilterInput: '고급 필터 입력',
  ariaChecked: '체크된',
  ariaColumn: '열',
  ariaColumnGroup: '열 그룹',
  ariaColumnFiltered: '필터된 열',
  ariaColumnSelectAll: '토글하여 모든 열 선택',
  ariaDateFilterInput: '날짜 필터 입력',
  ariaDefaultListName: '리스트',
  ariaFilterColumnsInput: '필터 열 입력',
  ariaFilterFromValue: '최소 값 필터',
  ariaFilterInput: '필터 입력',
  ariaFilterList: '필터 목록',
  ariaFilterToValue: '최대 값 필터',
  ariaFilterValue: '값 필터',
  ariaFilterMenuOpen: '필터 메뉴 열기',
  ariaFilteringOperator: '필터 연산자',
  ariaHidden: '숨은',
  ariaInputEditor: '입력 편집기',
  ariaMenuColumn: '열 메뉴를 열려면 CTRL ENTER 를 입력하세요',
  ariaRowDeselect: '이 열을 선택 해제하려면 SPACE 를 입력하세요',
  ariaRowSelectAll: '모든 행을 선택 또는 선택 해제하려면 Space 를 입력하세요',
  ariaRowToggleSelection: '행을 선택 또는 선택 해제하려면 Space 를 입력하세요',
  ariaRowSelect: '이 행을 선택하려면 SPACE 를 입력하세요',
  ariaSearch: '검색',
  ariaSortableColumn: '정렬하려면 ENTER 를 입력하세요',
  ariaToggleVisibility: '보기 여부를 변경하려면 SPACE 를 입력하세요',
  ariaToggleCellValue: '셀 값을 변경하려면 SPACE 를 입력하세요',
  ariaUnchecked: '체크 해제',
  ariaVisible: '보기',
  ariaSearchFilterValues: '필터 값을 검색하세요',
  ariaPageSizeSelectorLabel: '페이지 수',
  ariaRowGroupDropZonePanelLabel: '행 그룹',
  ariaValuesDropZonePanelLabel: '값',
  ariaPivotDropZonePanelLabel: '열 라벨',
  ariaDropZoneColumnComponentDescription: '삭제하려면 DELETE 을 입력하세요',
  ariaDropZoneColumnValueItemDescription: '집계 방식을 변경하려면 ENTER 를 입력하세요',
  ariaDropZoneColumnGroupItemDescription: '정렬하려면 ENTER 를 입력하세요',
  // used for aggregate drop zone, format: "{집계 방식}{열 집계 함수 연산자}{열 이름}",
  ariaDropZoneColumnComponentAggFuncSeparator: '중',
  ariaDropZoneColumnComponentSortAscending: '오름차순',
  ariaDropZoneColumnComponentSortDescending: '내림차순',
  ariaLabelColumnMenu: '열 메뉴',
  ariaLabelCellEditor: '셀 편집기',
  ariaLabelDialog: '대화창',
  ariaLabelSelectField: '선택 필드',
  ariaLabelRichSelectField: '다양한 선택 필드',
  ariaLabelTooltip: '툴팁',
  ariaLabelContextMenu: '컨텍스트 메뉴',
  ariaLabelSubMenu: '하위 메뉴',
  ariaLabelAggregationFunction: '집계 함수',
  ariaLabelAdvancedFilterAutocomplete: '고급 필터 자동채우기',
  ariaLabelAdvancedFilterBuilderAddField: '고급 필터 만들기 필터 추가',
  ariaLabelAdvancedFilterBuilderColumnSelectField: '고급 필터 만들기 열 선택 필드',
  ariaLabelAdvancedFilterBuilderOptionSelectField: '고급 필터 만들기 옵션 선택 필드',
  ariaLabelAdvancedFilterBuilderJoinSelectField: '고급 필터 만들기 연산자 선택 필드',
  ariaColumnPanelList: '열 목록',
  ariaFilterPanelList: '필터 목록',
  thousandSeparator: ',',
  decimalSeparator: '.',
  True: 'True',
  False: 'False',
  invalidDate: '유효하지 않은 날짜',
  invalidNumber: '유효하지 않은 숫자',
  january: '1월',
  february: '2월',
  march: '3월',
  april: '4월',
  may: '5월',
  june: '6월',
  july: '7월',
  august: '8월',
  september: '9월',
  october: '10월',
  november: '11월',
  december: '12월',
};

export default AG_GRID_LOCALE_KR;
